<section class="section bg-web-desc" id="blog">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <h2 class="text-center text-white">Ingresa a nuestro Blog</h2>
                <a href="https://www.willistowerswatson.com/es-ES" target="_blank" class="btn btn-bg-white margin-t-30 waves-effect waves-light">Encontrarás noticias relevantes https://www.willistowerswatson.com/es-ES</a>
            </div>
        </div>
    </div>
</section>
<!-- <section class="section bg-light" id="blog">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <h1 class="section-title text-center">Ingresa a nuestro Blog</h1>
                <div class="section-title-border margin-t-20"></div>
                <p class="section-subtitle text-muted text-center font-secondary padding-t-30">Encontrarás noticias relevantes https://www.willistowerswatson.com/es-ES
                </p>
            </div>
        </div>
    </div>
</section> -->